module.exports = __webpack_public_path__ + "assets/stanford-d16d59a4a486f426e710718094fbf96e.svg";